export const NatureTypes = Object.freeze({
    RELIGIOUS_ORDER: 'religious_order',
    SECULAR_INSTITUTE: 'secular_institute',
    APOSTOLIC_SOCIETY: 'apostolic_society',
    CATHOLIC_ACTION: 'catholic_action',
})

export const NatureTypeInfos = Object.freeze({
    RELIGIOUS_ORDER: {value: 'religious_order', label: 'Religious Order'},
    SECULAR_INSTITUTE: {value: 'secular_institute', label: 'Secular Institute',},
    APOSTOLIC_SOCIETY: {value: 'apostolic_society', label: 'Apostolic Society'},
    CATHOLIC_ACTION: {value: 'catholic_action', label: 'Catholic Action'},
})